import HealthPrograms from "@/pages/health-programs/index.vue";
import HealthProgramsHome from "@/pages/health-programs/home.vue";
import HealthProgramsHowWorks from "@/pages/health-programs/how_it_works.vue";
import Manifest from "@/pages/health-programs/manifest.vue";

const routes: Route[] = [
  {
    path: "/programas-de-saude",
    component: HealthPrograms,
    children: [
      {
        path: "",
        name: "programas_de_saude.home",
        component: HealthProgramsHome,
        meta: {
          backTo: "/",
          validPath: ["/"],
          registerAccess: {
            servico: "Programas de Saúde",
            funcionalidade: "Acesso a funcionalidade programas de saúde"
          }
        }
      },
      {
        path: "como-funciona",
        name: "programas_de_saude.como_funciona",
        component: HealthProgramsHowWorks,
        meta: {
          backTo: "/programas-de-saude",
          validPath: ["/", "/programas-de-saude/"]
        }
      },
      {
        path: "manifesto",
        name: "programas_de_saude.manifesto",
        component: Manifest,
        meta: {
          backTo: "/programas-de-saude",
          validPath: ["/", "/programas-de-saude/"]
        }
      }
    ]
  }
];

export default routes;
